import { render, staticRenderFns } from "./salaryreport.vue?vue&type=template&id=dfc0a9de&"
import script from "./salaryreport.vue?vue&type=script&lang=js&"
export * from "./salaryreport.vue?vue&type=script&lang=js&"
import style0 from "./salaryreport.vue?vue&type=style&index=0&id=dfc0a9de&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfc0a9de')) {
      api.createRecord('dfc0a9de', component.options)
    } else {
      api.reload('dfc0a9de', component.options)
    }
    module.hot.accept("./salaryreport.vue?vue&type=template&id=dfc0a9de&", function () {
      api.rerender('dfc0a9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/salaryreport.vue"
export default component.exports